export const industries = {
  'Automotive': ['gwi-ext.q1028b', 'q2d', 'q115', 'q3181', 'q31818e', 'q2155'],
  'Beauty': ['gwi-ext.q1038', 'q31817', 'q2155'],
  'Commerce': ['r4154new', 'q126d2', 'r52rcc', 'q125', 'q4165', 'q2155'],
  'Devices & Tech': ['q2021a', 'q39d', 'q39dsum', 'gwi-ext.q1058', 'gwi-ext.q1059', 'q31818a', 'q127ag2', 'q4163'],
  'Fashion': ['gwi-ext.q1030new', 'q31817', 'q48', 'q2155'],
  'Fitness & Health': ['q3181', 'q2021a', 'q3185a', 'q3185b', 'gwi-ext.q1029b', 'q3183', 'gwi-ext.q1046', 'q39d'],
  'FMCG / CPG': ['q2155', 'q31817b', 'q2156', 'q2155', 'q2158', 'q31818', 'q31817'],
  'Food & Drinks': ['q115', 'r3', 'q126d2', 'q31817a', 'gwi-ext.q1033b', 'gwi-ext.q1021newalc', 'q31817', 'q2158', 'gwi-ext.q1032b', 'q4165', 'q2155', 'q2157', 'q20'],
  'Gaming': ['q39d', 'q21510', 'q305', 'gwi-ext.q1020', 'q3162', 'q120b'],
  'Financial Services': ['q3181', 'q31818f', 'q31818b', 'gwi-ext.q1018b', 'gwi-ext.q1019b'],
  'Health  / Pharmaceutical': ['q3181d', 'q1045new', 'gwi-ext.q1046', 'q31817e', 'q2155'],
  'Travel': ['q31818c', 'q3181', 'q115', 'q31811', 'q31810', 'q31818c', 'q31818c', 'q126d2']
};


// b = ["gwi-ext.q1028b", "q2d", "q115", "q3181", "q31818e", "q2155", "gwi-ext.q1038", "q31817", "r4154new", "q126d2", "r52rcc", "q125", "q4165", "q2021a", "q39d", "q39dsum", "gwi-ext.q1058", "gwi-ext.q1059", "q31818a", "q127ag2", "q4163", "gwi-ext.q1030new", "q48", "q3185a", "q3185b", "gwi-ext.q1029b", "q3183", "gwi-ext.q1046", "q31817b", "q2156", "q2158", "q31818", "r3", "q31817a", "gwi-ext.q1033b", "gwi-ext.q1021newalc", "gwi-ext.q1032b", "q2157", "q20", "q21510", "q305", "gwi-ext.q1020", "q3162", "q120b", "q31818f", "q31818b", "gwi-ext.q1018b", "gwi-ext.q1019b", "q3181d", "q1045new", "q31817e", "q31818c", "q31810", "q31811"];

export const chartColors = ['#DD4689', '#295292', '#5ABDBA', '#E8E760', '#792F7B', '#C1DDAA', '#4965A1', '#F4BC96', '#85CABF', '#3E5155', '#1BA68B', '#60BA92', '#373A81', '#C47A76', '#8BAD9E', '#5E347F', '#715A8F', '#9D72A2', '#794047', '#E06867', '#1A5F97', '#954486', '#E25C84', '#5E347F', '#E88375', '#B5C866', '#2379B2', '#F9D777']

export const buttons = {
  persona: { url: '/personas/new', text: 'Generate Persona' },
  plan: { url: '/media_plans/new', text: 'Generate Plan' }
}

export const NumberFormatOptions = {
  displayType: 'text',
  thousandSeparator: ','
}
